

































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Mutation, State} from 'vuex-class'
import {Route} from 'vue-router'
import {Colors, notify} from '@/modules/core/notification'
import Gallery from '@/modules/cms/modules/gallery/model/Gallery'
import draggable from 'vuedraggable'
import GalleryItem from '@/modules/cms/modules/gallery/model/GalleryItem'
import FileSelector from '@/modules/media/components/FileSelector.vue'
import {MediaObject} from '@/modules/media/types'
import Loader from '@/components/Loader.vue'
import ConfirmDeleteGallery from '@/modules/cms/modules/gallery/components/ConfirmDeleteGallery.vue'

/**
 * Pantalla de edición de galerías
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        ConfirmDeleteGallery,
        Loader,
        FileSelector,
        draggable,
    },
})
export default class GalleryDetail extends Vue {
    /**
     * Galería actualmente seleccionada por el usuario, se muestra su información en
     * pantalla.
     */
    @State(state => state.cms.gallery.currentGallery)
    public gallery: Gallery

    /**
     * Elemento de la galería seleccionado
     */
    @State(state => state.cms.gallery.currentGalleryItem)
    public galleryItem: GalleryItem

    /**
     * Elimina un elemento de la galería actual según su identificador temporal
     */
    @Mutation('cms/gallery/DELETE_GALLERY_ITEM')
    public deleteItem: (tempId: string) => void

    public loading = false
    public creatingItem = false
    public fileSelector = false
    public saveConfirm = false
    public saving = false
    public confirmDeleteGallery = false

    /**
     * Lista de elementos en la galería
     */
    public get list () {
        return this.gallery.items
    }

    public set list (value: GalleryItem[]) {
        this.$store.commit('cms/gallery/UPDATE_CURRENT_GALLERY_FIELD', {
            field: 'items', value,
        })
    }

    public get canEditDetail () {
        return this.gallery.items.find(i => i.tempId === this.galleryItem.tempId) !== undefined
    }

    public get isMobile () {
        const breakpoint = this.$vuetify.breakpoint.name

        return breakpoint === 'xs' || breakpoint === 'sm'
    }

    public async created () {
        await this.loadGallery(this.$route)
    }

    public selectItem (item: GalleryItem) {
        this.$store.commit(
            'cms/gallery/SET_CURRENT_GALLERY_ITEM',
            item.tempId === this.galleryItem.tempId ? new GalleryItem() : item,
        )
    }

    public async onFileSelect (media: MediaObject | MediaObject[]) {
        if (!Array.isArray(media)) {
            media = [media]
        }

        if (this.creatingItem) {
            await this.$store.dispatch('cms/gallery/createGalleryItem', media.map(m => ({media: m})))
            this.creatingItem = false
        }

        this.$store.commit('cms/gallery/UPDATE_CURRENT_GALLERY_ITEM_FIELD', {
            field: 'media',
            value: media[0],
        })

        this.fileSelector = false
    }

    public async save () {
        this.saving = true

        await this.$store.dispatch('cms/gallery/saveGallery')

        // Si la ruta es nueva se inserta el id de la galería guardada
        if (this.$route.params.id === 'nueva') {
            await this.$router.replace({
                name: 'galleryDetail',
                params: { id: this.gallery.id.toString() },
            })
        }

        notify('La galería se ha guardado correctamente', Colors.Success, {
            goToAction: {
                buttonName: 'Ver galería',
                route: {
                    name: 'galleryDetail',
                    params: {id: this.gallery.id.toString()},
                },
            },
        })

        this.saveConfirm = false
        this.saving = false
    }

    /**
     * Con la información de la ruta el componente carga una galería desde el
     * servidor o inserta una nueva en el estado de la aplicación
     * para que el usuario pueda editarla y crearla
     *
     * @param route
     */
    public async loadGallery (route: Route) {
        this.loading = true
        let id: string | number = this.$route.params['id']

        // El usuario ha solicitado crea una nueva galería
        if (id === 'nueva') {
            await this.$store.dispatch('cms/gallery/loadNewGallery')
            this.loading = false

            return
        }

        id = parseInt(id, 10)
        if (!id || isNaN(id)) {
            notify('El id de la galería no es válida', Colors.Error)
            this.$router.push({name: 'dashboard'})
            this.loading = false

            return
        }

        try {
            await this.$store.dispatch('cms/gallery/loadGallery', id)
        } catch (e) {
            notify(e.message, Colors.Error)
            this.$router.push({name: 'galleryList'})
        }

        this.loading = false
    }

    /**
     * Captura cualquier error producido durante la ejecución del componente
     *
     * @param error
     */
    public errorCaptured (error: Error) {
        notify(error.message, Colors.Error)
        this.loading = false
        this.saving = false
    }
}
